import { WajeezFormInputV2 } from '@wajeez-web/components/form-builder';
import { useSetExpectedPublishDate } from '@wajeez-web/components/helpers';
import { ButtonHeadless, Modal } from '@wajeez-web/components/ui';
import { Server } from '@wajeez-web/core/api-base';
import { ReturnTranslatedText } from '@wajeez-web/core/localization';
import { Languages } from '@wajeez-web/core/utils';
import { setExpectedPublishDate } from '@wajeez-web/stores/content';
import { useForm } from 'react-hook-form';
import { BiLoaderAlt } from 'react-icons/bi';

interface ExpectedPublishDateModalProps {
  isOpen: boolean;
  onClose: () => void;
  contentEntityId: string;
  dateProfiles: { languageId: Languages; date: string | undefined }[];
  onSubmit: () => void;
}

export const ExpectedPublishDateModal = ({
  isOpen,
  onClose,
  contentEntityId,
  dateProfiles,
  onSubmit,
}: ExpectedPublishDateModalProps) => {
  const renderProfiles = () => {
    return dateProfiles.map((p, i) => {
      return (
        <div key={p.languageId} className={`pb-4`}>
          <ExpectedPublishDateForm
            contentEntityId={contentEntityId}
            languageId={p.languageId}
            date={p.date}
            onSubmit={onSubmit}
          />
        </div>
      );
    });
  };

  return (
    <Modal
      title={'Expected Publish Date'}
      open={isOpen}
      onClose={onClose}
      withScroll={true}
      handleAlert={false}
      alertTarget="modal"
      fontClassName="font-[Tajawal]"
    >
      <div>{renderProfiles()}</div>
    </Modal>
  );
};

interface ExpectedPublishDateFormProps {
  contentEntityId: string;
  languageId: Languages;
  date: string | undefined;
  onSubmit: () => void;
}

const ExpectedPublishDateForm = ({
  contentEntityId,
  languageId,
  date,
  onSubmit,
}: ExpectedPublishDateFormProps) => {
  const status = useSetExpectedPublishDate(languageId);

  const { handleSubmit, control } =
    useForm<Server.SetContentEntityExpectedPublishDateInput>({
      defaultValues: {
        id: contentEntityId,
        languageId,
        expectedPublishDate: date,
      },
    });

  const onFormSubmit = (
    data: Server.SetContentEntityExpectedPublishDateInput
  ) => {
    setExpectedPublishDate(data, onSubmit);
  };

  return (
    <form
      noValidate
      onSubmit={handleSubmit(onFormSubmit)}
      className="w-full flex justify-start items-end"
    >
      <div className="w-[300px]">
        <WajeezFormInputV2
          name="expectedPublishDate"
          control={control}
          fieldMeta={{
            fieldType: Server.FieldType.Date,
            fieldOptions: {},
            placeHolder: `${
              languageId === Languages.AR ? 'Arabic' : 'English'
            } Expected Publish Date`,
            label: `${
              languageId === Languages.AR ? 'Arabic' : 'English'
            } Expected Publish Date`,
            required: true,
          }}
        />
      </div>
      <div className="ms-4 w-[70px]">
        <ButtonHeadless
          paddingYStyle="py-[4px]"
          borderRadiusStyle="rounded-[4px]"
          type="submit"
          isDisabled={status?.status === 'loading'}
        >
          <div className="w-full flex justify-center items-center text-white">
            <ReturnTranslatedText text="buttons.Save" origintext="Save" />
            <div className="ms-2">
              {status?.status === 'loading' && (
                <BiLoaderAlt className="animate-spin w-5" />
              )}
            </div>
          </div>
        </ButtonHeadless>
      </div>
    </form>
  );
};
